import axios, { resHandle } from "@/plugins/axios";

/**
 * @description 删除标注数据
 * @param vCom Vue组件
 */
const deleteLabledTongue = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete("api/zwb/patient/tongue/imgargs", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 历史标注记录
 * @param vCom Vue组件
 */
const getLableHistory = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/zwb/patient/tongue/logs", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 舌象数据-科研版-中医观察指标 获取详情
 * @param vCom Vue组件
 */
const getZhuanjia = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/zwb/patient/labeled/tongue", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 舌图列表页
 * @param vCom Vue组件
 */
const getTongueMessages = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/research/tongues", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 中医观察指标/舌图标签 获取详情
 * @param vCom Vue组件
 */
const getGuanchazhibiaoAndBiaoqian = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/zwb/patient/tongue/imgargs", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 舌象数据-科研版-中医观察指标 初始值
 * @param vCom Vue组件
 */
const getGuanchazhibiaoChushizhi = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/zwb/patient/tongue/init/imgargs").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 中医观察指标/舌图标签 标注
 * @param params 参数
 */
const saveGuanchazhibiaoAndBiaoqian = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/patient/tongue/imgargs", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 舌象数据-科研版-颜色特征 获取详情
 * @param vCom Vue组件
 */
const getYansetezheng = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/zwb/patient/tongue/imgcolor", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 舌象数据-科研版-纹理特征 获取详情
 * @param vCom Vue组件
 */
const getWenlitezheng = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/zwb/patient/tongue/imgwenli", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 舌象数据-科研版-舌图标签 获取详情(废弃)
 * @param vCom Vue组件
 */
const getBiaoqianDetail = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/zwb/patient/tongue/label", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 舌象数据-科研版-舌图标签 获取详情
 * @param vCom Vue组件
 */
const saveBiaoqianDetail = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/patient/tongue/label", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};



/**
 * @description 舌象数据-科研版-标签 列表
 */
const getBiaoqianList = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/zwb/user/tags").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 舌象数据-科研版-标签 修改
 */
const saveBiaoqianList = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/user/tags", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 数据中心列表
 * @param vCom Vue组件
 */
const GetCenter = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/center/list").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 【副本】数据中心下面的用户所属分中心列表
 * @param vCom Vue组件
 */
const GetHospitalsOfUserInCenter = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/project/user/hospitals", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 单个导入中医影像中心或治未病中心的患者到 临床或传承中心
 * @param vCom Vue组件
 */
const ImportPatientToCenter = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/center/import/patient", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 智能比对-中医观察指标
 * @param vCom Vue组件
 */
const getBiduiZygczb = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/duibi/tongue/imgargs", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 智能比对-颜色特征
 * @param vCom Vue组件
 */
const getBiduiYanse = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/duibi/tongue/imgcolor", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 智能比对-纹理特征
 * @param vCom Vue组件
 */
const getBiduiWenli = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/duibi/tongue/imgwenli", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 智能比对-舌图标签
 * @param vCom Vue组件
 */
const getBiduiBiaoqian = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/duibi/tongue/label", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 预览-智能比对-中医观察指标
 * @param vCom Vue组件
 */
const getBiduiPreviewZygczb = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/preview/tongue/imgargs", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 预览-智能比对-颜色特征
 * @param vCom Vue组件
 */
const getBiduiPreviewYanse = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/preview/tongue/imgcolor", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 预览-智能比对-纹理特征
 * @param vCom Vue组件
 */
const getBiduiPreviewWenli = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/preview/tongue/imgwenli", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 预览-智能比对-舌图标签
 * @param vCom Vue组件
 */
const getBiduiPreviewBiaoqian = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/preview/tongue/label", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 导出比对舌图数据
 * @param vCom Vue组件
 */
const exportBiduiData = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/export/duibi/tongues", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 舌图分割预览
 * @param vCom Vue组件
 */
const customCutTonguePreview = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/tongue/label/cut", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 舌图分割保存
 * @param vCom Vue组件
 */
const customCutTongueSave = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.put("api/zwb/tongue/label/cut", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 临床科室数据中心数据导出
 * @param vCom Vue组件
 */
const PostDataExport = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/export/imgcenter", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};


export {
    deleteLabledTongue,
    getLableHistory,
    getZhuanjia,
    getTongueMessages,
    getGuanchazhibiaoAndBiaoqian,
    saveGuanchazhibiaoAndBiaoqian,
    getGuanchazhibiaoChushizhi,
    getYansetezheng,
    getWenlitezheng,
    getBiaoqianDetail,
    saveBiaoqianDetail,
    getBiaoqianList,
    saveBiaoqianList,
    GetCenter,
    GetHospitalsOfUserInCenter,
    ImportPatientToCenter,
    getBiduiZygczb,
    getBiduiYanse,
    getBiduiWenli,
    getBiduiBiaoqian,
    getBiduiPreviewZygczb,
    getBiduiPreviewYanse,
    getBiduiPreviewWenli,
    getBiduiPreviewBiaoqian,
    exportBiduiData,
    customCutTonguePreview,
    customCutTongueSave,
    PostDataExport
};
